import {taskList, projectCreate, unassociatedList, projectShow, projectUpdate, projectList } from '@/api/task-project.js'
import { mapActions } from 'vuex'
export const Project = {
  data () {
    return {
      updateStat:true,
      RenderKey:true,
      submitTaskFromProjectDetails: false,
      checkIndex: '',
      itemIndex: '',
      mainIndex: '',
      editChecklistName: '',
      projectChecklistEditPopup: false,
      projectChecklistEditPopup2: false,
      ListOfProjectData: [],
      pageLimitOPtion: [
        {
          name: 5,
          value: 5
        },
        {
          name: 10,
          value: 10
        },
        {
          name: 20,
          value: 20
        }
      ],
      pageLimitSet: 5,
      meta: {
        current_page: 1,
        has_next: false,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      meta_template: {
        current_page: 1,
        has_next: false,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      meta_task: {
        current_page: 1,
        has_next: false,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      query_page: {
        page: 1,
        limit: 10
      },
      ListOfTask: [],
      ListOfLiveTask: [],
      all_task_details: [
        {
          id: '',
          tId: '',
          name : '',
          due_date: '',
          task_priority_id : '',
          task_status_id: '',
          comments: '',
          details: '',
          is_tracking_active: false,
          clientObserver:[],
          clientParticipant:[],
          clientResponsiblePerson:[],
          userObserver:[],
          userParticipant:[],
          userResponsiblePerson:[],
          timeSchedules:[],
          projectStatusTag: '',
          checklist:[],
          is_template: false,
          ResponsiblePersonData: [],
          ParticipantPersonData: [],
          observerPersonData: [],
          selectedSubTaskData: [],
          selectedCRMData: [],
          reminderTime: [],
          from_time: '',
          to_time: '',
          checklistRows: [],
          project: null,
          tags: [],
          subtask: [],
          leads: [],
          reminder: [],
          configdateTimePicker: {
            enableTime: true,
            enableSeconds: true,
            noCalendar: false,
            maxDate: '',
            maxTime: '',
            //time_24hr: localStorage.getItem('time') == 2,
            altInput: true,
            altFormat: 'j F, Y G:i K',
            dateFormat: 'Y-m-d H:i:S'
            //altFormat: localStorage.getItem('time') == 2 ? `${localStorage.getItem('date_format')  } H:i:S` : `${localStorage.getItem('date_format')  } h:i:S K`
          },
          configdateTimePicker2: {
            enableTime: true,
            noCalendar: false,
            maxDate: '',
            maxTime: '',
            minDate: new Date(),
            altInput: true,
            altFormat: 'j F, Y G:i K',
            dateFormat: 'Y-m-d H:i:S'          }
        }
      ],
      projectData: {
        name: '',
        details: '',
        due_date: '',
        liveTask: [],
        attachLiveTask: [],
        userProjectMember: [],
        clientProjectMember: [],
        projectStatusTag: []
      },
      projectDetailsData: [],
      taskRow: '',
      memberData: [],
      typeOfPerson:'',
      typeOfPersonTitle: '',
      popupActive: false,
      popupresponse: false,
      liveTaskImportData: [],
      projectUpdateId: '',
      editorComponent:null,
      isBrowseContent:false,
      modalType:'create',
      statusindex:'',
      Oldstatusname:''
    }
  },
  created () {
    this.checkPermissionForStaff()
  },
  methods: {
    editItemFromStatus (index, taskStatus) {
      console.log(taskStatus, index)
      this.statusActive = true
      this.statusname = taskStatus.name
      this.Oldstatusname = taskStatus.name
      this.statusindex = index
      this.modalType = 'update'
    },
    addTaskStatus () {
      this.allTaskStatus.push({
        id: this.allTaskStatus.length + 1,
        name: this.statusname
      })
      this.statusname = ''
      this.statusActive = false
    },
    updateTaskStatus () {
      this.all_task_details.forEach(ele => {
        if (ele.projectStatusTag === this.Oldstatusname) {
          ele.projectStatusTag = this.statusname
         
        }
      })

      this.allTaskStatus[this.statusindex].name =
      this.allTaskStatus[this.statusindex] = {
        id:  this.allTaskStatus[this.statusindex].id,
        name: this.statusname
      }
      this.updateStat = !this.updateStat
      this.statusActive = false
      this.modalType = 'create'
      this.statusname = ''
    },
    closeStatus (index) {
      this.allTaskStatus.splice(index, 1)
    },
    checkPermissionForStaff () {
      const role_permission = parseInt(localStorage.getItem('role_permission'))
      if (role_permission === 1) {
        this.schoolAdmin = true
      } else {
        this.schoolAdmin = false
        this.getModulePermission('Tasks')
        this.getModulePermission('Projects')
      }
    },
    addNewTask () {
      this.all_task_details = [
        {
          id: '',
          tId: '',
          name : '',
          due_date: '',
          task_priority_id : '',
          task_status_id: '',
          comments: '',
          details: '',
          clientObserver:[],
          clientParticipant:[],
          clientResponsiblePerson:[],
          userObserver:[],
          userParticipant:[],
          userResponsiblePerson:[],
          timeSchedules:[],
          projectStatusTag: '',
          checklist:[],
          is_template: false,
          ResponsiblePersonData: [],
          ParticipantPersonData: [],
          observerPersonData: [],
          selectedSubTaskData: [],
          selectedCRMData: [],
          reminderTime: [],
          from_time: '',
          to_time: '',
          is_tracking_active: false,
          checklistRows: [],
          tags: [],
          subtask: [],
          leads: [],
          reminder: [],
          configdateTimePicker: {
            enableTime: true,
            // enableSeconds: true,
            noCalendar: false,
            maxDate: '',
            maxTime: '',
            altInput: true,
            altFormat: 'j F, Y G:i K',
            dateFormat: 'Y-m-d H:i:S'
          },
          configdateTimePicker2: {
            enableTime: true,
            //enableSeconds: true,
            noCalendar: false,
            maxDate: '',
            minDate: new Date(),
            maxTime: '',
            // time_24hr: localStorage.getItem('time') == 2,
            altInput: true,
            altFormat: 'j F, Y G:i K',
            dateFormat: 'Y-m-d H:i:S'
            // altFormat: localStorage.getItem('time') == 2 ? `${localStorage.getItem('date_format')  } H:i:S` : `${localStorage.getItem('date_format')  } h:i:S K`
          }
        },
        ...this.all_task_details,
      ]
      this.ProjectDueDate()
    },
    removeCard (index) {
      if (this.all_task_details.length === 1) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Sorry! you can\'t remove this task',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } else {
        this.all_task_details.splice(index, 1)
      }
    },
    addItemNew (index, id) {
      console.log(this.all_task_details[index].checklist[id])
      this.all_task_details[index].checklist[id].showTextBox.push({itemName: ''})
      this.RenderKey = !this.RenderKey
    },
    submitItemNew (index1, index3, data) { 
      for (let index = 0; index < data.showTextBox.length; index++) {
        if (data.showTextBox[index].itemName !== '') {
          this.all_task_details[index1].checklist[index3].todos.push({
            todo: data.showTextBox[index].itemName,
            is_completed: false
          })
        }
      }
      for (let index = 0; index < data.showTextBox.length; index++) {
        data.showTextBox[index].itemName = ''
      }
      this.all_task_details[index1].checklist[index3].showTextBox = []  
    },
    removeItemNew (index1, index2, index3) { 
      this.all_task_details[index1].checklist[index2].showTextBox.splice(index3, 1)
    },
    async fetchProject (query, filterData = null) {
      try {
        this.$vs.loading({
          type: 'radius'
        })
        const { data } = await projectList(localStorage.getItem('customer_id'), query, filterData)
        const table = data.data.project
        this.meta = data.data.meta
        table.map((row, index) => {
          const row_index = index + 1
          const checkProjectEditPermission = this.checkProjectEditPermission()
          const checkProjectDeletePermission = this.checkProjectDeletePermission()
          Object.assign(row, { row_index })
          Object.assign(row, { checkProjectEditPermission })
          Object.assign(row, { checkProjectDeletePermission })
        })
        this.$vs.loading.close()
        this.ListOfProjectData = table
        this.projectList = this.ListOfProjectData
        this.projectListMeta = data.data.meta
      } catch (e) {
        
        this.$vs.loading.close()
      }
    },
    async fetchTask (query) {
      try {
        this.$vs.loading({
          type: 'radius'
        })

        
        const { data } = await taskList(localStorage.getItem('customer_id'), query)
        
        const table = data.data.taskTemplates
        this.meta_template = data.data.meta_template
        table.map((row, index) => {
          const row_index = index + 1
          Object.assign(row, { row_index })
        })
        this.$vs.loading.close()
        this.ListOfTask = table
      } catch (e) {
        
        this.$vs.loading.close()
      }
    },
    fetchLiveTask (query) {
      unassociatedList(localStorage.getItem('customer_id'), query)
        .then((res) => {
          this.meta = res.data.data.meta
          
          this.liveTaskImportData = res.data.data.tasks
        })
        .catch((e) => {
          
        })
    },   
    async loadMoreTemplate (showType) {
      if (showType === 'plus') {
        this.meta_template.current_page = this.meta_template.current_page + 1
      } else {
        this.meta_template.current_page = this.meta_template.current_page - 1
      }
      const queryParameter = {}
      queryParameter.page = this.meta_template.current_page
      queryParameter.limit = 20
      this.fetchTask(queryParameter)
    },
    async loadMoreTask (showType) {
      if (showType === 'plus') {
        this.meta.current_page = this.meta.current_page + 1
      } else {
        this.meta.current_page = this.meta.current_page - 1
      }
      this.fetchLiveTask(this.meta.current_page)
    },
    paginationPageSize () {
      return this.pageLimitSet
    },
    addMoreUserProject (data, index) {
      this.typeOfPerson = data
      if (data === 'ResponsiblePerson') {
        this.typeOfPersonTitle = 'Add Responsible Person'
        this.popupresponse = true 
      } else if (data === 'ParticipantPerson') {
        this.typeOfPersonTitle = 'Add Participants'
        this.popupActive = true 
      } else if (data === 'observerPerson') {
        this.typeOfPersonTitle = 'Add Observers'
        this.popupActive = true 
      } else {
        this.typeOfPersonTitle = `Add ${data  }`
        this.popupActive = true 
      }
     
      this.taskRow = index
    },
    closeSelectedProject (data, index, index1) {
      if (data === 'Member') {
        this.memberData.splice(index, 1)
      } else if (data === 'ResponsiblePerson') {
        this.all_task_details[index1].ResponsiblePersonData.splice(index, 1)
      } else if (data === 'ParticipantPerson') {
        this.all_task_details[this.taskRow].ParticipantPersonData.splice(index, 1)
      } else if (data === 'subTask') {
        this.all_task_details[this.taskRow].selectedSubTaskData.splice(index, 1)
      } else if (data === 'CRM') {
        this.all_task_details[this.taskRow].selectedCRMData.splice(index, 1)
      } else {
        this.all_task_details[this.taskRow].observerPersonData.splice(index, 1)
      }
    },
    replaceURLs (message) {
      if (!message) return
      const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g
      return message.replace(urlRegex, function (url) {
        let hyperlink = url
        // eslint-disable-next-line no-useless-escape
        if (!hyperlink.match('^https?:\/\/')) {
          hyperlink = `http://${  hyperlink}`
        }
        return `<a href="${  hyperlink  }" target="_blank" rel="noopener noreferrer">${  url  }</a>`
      })
    },
    addChecklistProject (index) {
      this.all_task_details[index].checklistRows.push({
        name:'',
        showTextBox: [],
        items: [],
        itemStatusCal: []
      })
    },
    removeChecklistProject (index, index3) {
      this.all_task_details[index].checklistRows.splice(index3, 1)
    },
    submitItemProject (rowIndex, index3, data) { 
      for (let index = 0; index < data.showTextBox.length; index++) {
        if (data.showTextBox[index].itemName !== '') {
          this.all_task_details[rowIndex].checklistRows[index3].items.push({
            todo: data.showTextBox[index].itemName,
            is_completed: false
          })
        }
      }
      for (let index = 0; index < data.showTextBox.length; index++) {
        data.showTextBox[index].itemName = ''
      }
      this.all_task_details[rowIndex].checklistRows[index3].showTextBox = []
    },
    deleteItemProject (rowIndex, index3, index) {
      if (this.all_task_details[rowIndex].checklist.length !== 0) {
        if (this.all_task_details[rowIndex].checklist[index3].todos.length === 1) {
          this.all_task_details[rowIndex].checklist.splice(index3, 1)
        } else {
          if (this.all_task_details[rowIndex].checklist[index3].todos[index].is_completed === true) {
            this.all_task_details[rowIndex].checklist[index3].itemStatusCal.length = this.all_task_details[rowIndex].checklist[index3].itemStatusCal.length - 1
          }
          this.all_task_details[rowIndex].checklist[index3].todos.splice(index, 1)
        }
      }
    },
    editItemProjectFromCheck (index, index3, index6, data) {
      this.editChecklistName = data.todo
      this.projectChecklistEditPopup = true
      this.mainIndex = index
      this.checkIndex = index3
      this.itemIndex = index6
    },
    editItemProject (index, index3, index6, data) {
      this.editChecklistName = data.todo
      this.projectChecklistEditPopup2 = true
      this.mainIndex = index
      this.checkIndex = index3
      this.itemIndex = index6
    },
    updateItemProject () {
      if (this.editChecklistName !== '') {
        console.log(this.all_task_details[this.mainIndex].checklist)
        this.all_task_details[this.mainIndex].checklist[this.checkIndex].todos[this.itemIndex].todo = this.editChecklistName
        this.projectChecklistEditPopup2 = false
      }
    },
    updateItemProjectForCheck () {
      if (this.editChecklistName !== '') {
        this.all_task_details[this.mainIndex].checklistRows[this.checkIndex].items[this.itemIndex].todo = this.editChecklistName
        this.projectChecklistEditPopup = false
      }
    },
    deleteItemProjectFromCheck (rowIndex, index3, index) {
      if (this.all_task_details[rowIndex].checklistRows.length !== 0) {
        if (this.all_task_details[rowIndex].checklistRows[index3].items.length === 1) {
          this.all_task_details[rowIndex].checklistRows.splice(index3, 1)
        } else {
          if (this.all_task_details[rowIndex].checklistRows[index3].items[index].is_completed === true) {
            this.all_task_details[rowIndex].checklistRows[index3].itemStatusCal.length = this.all_task_details[rowIndex].checklistRows[index3].itemStatusCal.length - 1
          }
          this.all_task_details[rowIndex].checklistRows[index3].items.splice(index, 1)
        }
      }
    },
    changeStatusProject (rowIndex, index3, index) {
      if (this.all_task_details[rowIndex].checklist.length !== 0) {
        if (this.all_task_details[rowIndex].checklist[index3].todos[index].is_completed === true) {
          this.all_task_details[rowIndex].checklist[index3].todos[index].is_completed = true
          this.all_task_details[rowIndex].checklist[index3].itemStatusCal.length = this.all_task_details[rowIndex].checklist[index3].itemStatusCal.length + 1
        } else {
          this.all_task_details[rowIndex].checklist[index3].todos[index].is_completed = false
          this.all_task_details[rowIndex].checklist[index3].itemStatusCal.length = this.all_task_details[rowIndex].checklist[index3].itemStatusCal.length - 1
        }
      }
      
    },
    changeStatusProjectFromCheck (rowIndex, index3, index) {
      if (this.all_task_details[rowIndex].checklistRows.length !== 0) {
        if (this.all_task_details[rowIndex].checklistRows[index3].items[index].is_completed === true) {
          this.all_task_details[rowIndex].checklistRows[index3].items[index].is_completed = true
          this.all_task_details[rowIndex].checklistRows[index3].itemStatusCal.length = this.all_task_details[rowIndex].checklistRows[index3].itemStatusCal.length + 1
        } else {
          this.all_task_details[rowIndex].checklistRows[index3].items[index].is_completed = false
          this.all_task_details[rowIndex].checklistRows[index3].itemStatusCal.length = this.all_task_details[rowIndex].checklistRows[index3].itemStatusCal.length - 1 
        }
      }
      
    },
    addUserProjectResponsible () {
      const arr = []
      if (this.typeOfPerson === 'ResponsiblePerson') {
        if (Object.keys(this.selectedUsers).length > 0) {
          arr.push({
            first_name: this.selectedUsers.first_name,
            last_name: this.selectedUsers.last_name,
            user_type: this.selectedUsers.user_type,
            users_id: this.selectedUsers.users_id,
            picture: this.selectedUsers.picture
          })
        }
        if (Object.keys(this.selectedClients).length > 0) {
          arr.push({
            first_name: this.selectedClients.first_name,
            last_name: this.selectedClients.last_name,
            user_type: this.selectedClients.user_type,
            users_id: this.selectedClients.client_users_id,
            picture: this.selectedClients.picture
          })
        }
      } else {
        for (let i = 0; i < this.selectedUsers.length; i++) {
          arr.push({
            first_name: this.selectedUsers[i].first_name,
            last_name: this.selectedUsers[i].last_name,
            user_type: this.selectedUsers[i].user_type,
            users_id: this.selectedUsers[i].users_id,
            picture: this.selectedUsers[i].picture
          })
        }
        for (let i = 0; i < this.selectedClients.length; i++) {
          arr.push({
            first_name: this.selectedClients[i].first_name,
            last_name: this.selectedClients[i].last_name,
            user_type: this.selectedClients[i].user_type,
            users_id: this.selectedClients[i].client_users_id,
            picture: this.selectedClients[i].picture
          })
        }
      }
      
      if (this.typeOfPerson === 'Member') {
        const res2 = this.memberData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.users_id === o2.users_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].users_id
            this.memberData = this.memberData.filter(
              (item) => item.users_id !== idToRemove
            )
          }
        }
        this.memberData = arr.concat(this.memberData)
      } else if (this.typeOfPerson === 'ResponsiblePerson') {
        const res2 = this.all_task_details[this.taskRow].ResponsiblePersonData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.users_id === o2.users_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].users_id
            this.all_task_details[this.taskRow].ResponsiblePersonData = this.all_task_details[this.taskRow].ResponsiblePersonData.filter(
              (item) => item.users_id !== idToRemove
            )
          }
        }
        this.all_task_details[this.taskRow].ResponsiblePersonData = arr.concat(this.all_task_details[this.taskRow].ResponsiblePersonData)
      } else if (this.typeOfPerson === 'ParticipantPerson') {
        const res2 = this.all_task_details[this.taskRow].ParticipantPersonData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.users_id === o2.users_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].users_id
            this.all_task_details[this.taskRow].ParticipantPersonData = this.all_task_details[this.taskRow].ParticipantPersonData.filter(
              (item) => item.users_id !== idToRemove
            )
          }
        }
        this.all_task_details[this.taskRow].ParticipantPersonData = arr.concat(this.all_task_details[this.taskRow].ParticipantPersonData)
      } else {
        const res2 = this.all_task_details[this.taskRow].observerPersonData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.users_id === o2.users_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].users_id
            this.all_task_details[this.taskRow].observerPersonData = this.all_task_details[this.taskRow].observerPersonData.filter(
              (item) => item.users_id !== idToRemove
            )
          }
        }
        this.all_task_details[this.taskRow].observerPersonData = arr.concat(this.all_task_details[this.taskRow].observerPersonData)
      }
      this.selectedUsers = []
      this.selectedClients = []
      this.popupresponse = false 
    },
    addUserProject () {
      const arr = []
      for (let i = 0; i < this.selectedUsers.length; i++) {
        arr.push({
          first_name: this.selectedUsers[i].first_name,
          last_name: this.selectedUsers[i].last_name,
          user_type: this.selectedUsers[i].user_type,
          users_id: this.selectedUsers[i].users_id,
          picture: this.selectedUsers[i].picture
        })
      }
      for (let i = 0; i < this.selectedClients.length; i++) {
        arr.push({
          first_name: this.selectedClients[i].first_name,
          last_name: this.selectedClients[i].last_name,
          user_type: this.selectedClients[i].user_type,
          users_id: this.selectedClients[i].client_users_id,
          picture: this.selectedClients[i].picture
        })
      }
      if (this.typeOfPerson === 'Member') {
        const res2 = this.memberData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.users_id === o2.users_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].users_id
            this.memberData = this.memberData.filter(
              (item) => item.users_id !== idToRemove
            )
          }
        }
        this.memberData = arr.concat(this.memberData)
      } else if (this.typeOfPerson === 'ResponsiblePerson') {
        const res2 = this.all_task_details[this.taskRow].ResponsiblePersonData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.users_id === o2.users_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].users_id
            this.all_task_details[this.taskRow].ResponsiblePersonData = this.all_task_details[this.taskRow].ResponsiblePersonData.filter(
              (item) => item.users_id !== idToRemove
            )
          }
        }
        this.all_task_details[this.taskRow].ResponsiblePersonData = arr.concat(this.all_task_details[this.taskRow].ResponsiblePersonData)
      } else if (this.typeOfPerson === 'ParticipantPerson') {
        const res2 = this.all_task_details[this.taskRow].ParticipantPersonData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.users_id === o2.users_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].users_id
            this.all_task_details[this.taskRow].ParticipantPersonData = this.all_task_details[this.taskRow].ParticipantPersonData.filter(
              (item) => item.users_id !== idToRemove
            )
          }
        }
        this.all_task_details[this.taskRow].ParticipantPersonData = arr.concat(this.all_task_details[this.taskRow].ParticipantPersonData)
      } else {
        const res2 = this.all_task_details[this.taskRow].observerPersonData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.users_id === o2.users_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].users_id
            this.all_task_details[this.taskRow].observerPersonData = this.all_task_details[this.taskRow].observerPersonData.filter(
              (item) => item.users_id !== idToRemove
            )
          }
        }
        this.all_task_details[this.taskRow].observerPersonData = arr.concat(this.all_task_details[this.taskRow].observerPersonData)
      }
      this.selectedUsers = []
      this.selectedClients = []
      this.popupActive = false 
    },
    submitProject () {
      if (this.all_task_details.length === 1) {
        if (this.all_task_details[0].name === '' || this.all_task_details[0].task_priority_id === '' || this.all_task_details[0].projectStatusTag === '' || this.all_task_details[0].ResponsiblePersonData.length === 0) {
          this.warningPopupMessage('You have to create atleast one task')
          throw new Error('Something Went Badly Wrong')
        }
      }
      for (let index = 0; index < this.all_task_details.length; index++) {
        if (this.all_task_details[index].name !== '') {
          if (this.all_task_details[index].tId === null || this.all_task_details[index].tId === '') {
            if (this.all_task_details[index].ResponsiblePersonData.length !== 0) {
              if (this.all_task_details[index].is_template === '1' || this.all_task_details[index].is_template === true) {
                this.all_task_details[index].is_template = true
              } else {
                this.all_task_details[index].is_template = false
              }
              if (this.all_task_details[index].ResponsiblePersonData.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].ResponsiblePersonData.length; i++) {
                  if ('user_type' in this.all_task_details[index].ResponsiblePersonData[i]) {
                    if (this.all_task_details[index].ResponsiblePersonData[i].user_type === 0) {
                      this.all_task_details[index].userResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].users_id) 
                    } else {
                      this.all_task_details[index].clientResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].users_id)
                    } 
                  } 
                  if ('pivot' in this.all_task_details[index].ResponsiblePersonData[i]) {
                    if (this.all_task_details[index].ResponsiblePersonData[i].pivot.responsible_persons_type === 0) {
                      this.all_task_details[index].userResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].pivot.responsible_persons_id) 
                    } else {
                      this.all_task_details[index].clientResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].pivot.responsible_persons_id)
                    }  
                  }
                }
              }

              if (this.all_task_details[index].ParticipantPersonData.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].ParticipantPersonData.length; i++) {
                  if ('user_type' in this.all_task_details[index].ParticipantPersonData[i]) {
                    if (this.all_task_details[index].ParticipantPersonData[i].user_type === 0) {
                      this.all_task_details[index].userParticipant.push(this.all_task_details[index].ParticipantPersonData[i].users_id) 
                    } else {
                      this.all_task_details[index].clientParticipant.push(this.all_task_details[index].ParticipantPersonData[i].users_id)
                    }  
                  } 
                  if ('pivot' in this.all_task_details[index].ParticipantPersonData[i]) {
                    if (this.all_task_details[index].ParticipantPersonData[i].pivot.participants_type === 0) {
                      this.all_task_details[index].userParticipant.push(this.all_task_details[index].ParticipantPersonData[i].pivot.participants_id) 
                    } else {
                      this.all_task_details[index].clientParticipant.push(this.all_task_details[index].ParticipantPersonData[i].pivot.participants_id)
                    }  
                  }
                }
              }
       
              if (this.all_task_details[index].observerPersonData.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].observerPersonData.length; i++) {
                  if ('user_type' in this.all_task_details[index].observerPersonData[i]) {
                    if (this.all_task_details[index].observerPersonData[i].user_type === 0) {
                      this.all_task_details[index].userObserver.push(this.all_task_details[index].observerPersonData[i].users_id) 
                    } else {
                      this.all_task_details[index].clientObserver.push(this.all_task_details[index].observerPersonData[i].users_id)
                    }  
                  } 
                  if ('pivot' in this.all_task_details[index].observerPersonData[i]) {
                    if (this.all_task_details[index].observerPersonData[i].pivot.observers_type === 0) {
                      this.all_task_details[index].userObserver.push(this.all_task_details[index].observerPersonData[i].pivot.observers_id) 
                    } else {
                      this.all_task_details[index].clientObserver.push(this.all_task_details[index].observerPersonData[i].pivot.observers_id)
                    }  
                  }
                }
              }
              if (this.all_task_details[index].selectedSubTaskData.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].selectedSubTaskData.length; i++) {
                  this.all_task_details[index].subtask.push(this.all_task_details[index].selectedSubTaskData[i].id) 
                }
              }
              if (this.all_task_details[index].selectedCRMData.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].selectedCRMData.length; i++) {
                  this.all_task_details[index].leads.push(this.all_task_details[index].selectedCRMData[i].leads_id) 
                }
              }
              if (this.all_task_details[index].reminderTime.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].reminderTime.length; i++) {
                  this.all_task_details[index].reminder.push({
                    reminder_type: 1,
                    reminder_time: this.all_task_details[index].reminderTime[i].reminder_time
                  }) 
                }
              }

              if (this.all_task_details[index].checklistRows.length !== 0 || this.all_task_details[index].checklist.length !== 0) {
                for (let index2 = 0; index2 < this.all_task_details[index].checklist.length; index2++) {
                  if ('todos' in this.all_task_details[index].checklist[index2]) {
                    if (this.all_task_details[index].checklist[index2].todos.length === 0) this.all_task_details[index].checklist.splice(index2, 1)
                  }
                }
                for (let i = 0; i < this.all_task_details[index].checklistRows.length; i++) {
                  if (this.all_task_details[index].checklistRows[i].items.length === 0) {
                    this.all_task_details[index].checklistRows.splice(index, 1)
                  } else {
                    const result = this.all_task_details[index].checklistRows[i].items.map(function (el) {
                      const o = Object.assign({}, el)
                      o.order_id = 0
                      return o
                    })
                    for (let j = 0; j < result.length; j++) {
                      this.all_task_details[index].checklistRows[i].items[j].order_id = j + 1
                    }
                    this.all_task_details[index].checklist.push({
                      name: `Checklist${ i + 1}`,
                      todos: this.all_task_details[index].checklistRows[i].items
                    })
                  }
      
                }
              }
              this.projectData.liveTask.push(this.all_task_details[index]) 
            } else {
              this.warningPopupMessage('Responsible person is required')
              throw new Error('Something Went Badly Wrong')
            }
          } else {
            this.projectData.attachLiveTask.push({
              id: this.all_task_details[index].tId,
              project_status_name: this.all_task_details[index].projectStatusTag

            })
          }
        }
      }
      if (this.memberData.length !== 0) {
        for (let i = 0; i < this.memberData.length; i++) {
          if (this.memberData[i].user_type === 0) {
            this.projectData.userProjectMember.push(this.memberData[i].users_id) 
          } else {
            this.projectData.clientProjectMember.push(this.memberData[i].users_id)
          }  
        }
      }
      for (let i = 0; i < this.allTaskStatus.length; i++) {
        this.projectData.projectStatusTag.push({
          name: this.allTaskStatus[i].name,
          weighted_order_id: i + 1
        }) 
      }
      this.projectData.liveTask.forEach(e => { delete e.ParticipantPersonData })
      this.projectData.liveTask.forEach(e => { delete e.observerPersonData })
      this.projectData.liveTask.forEach(e => { delete e.checklistRows })
    
     
      this.createProject(this.projectData)
    },
    createProject (data) {   
      console.log(data)    
      projectCreate(localStorage.getItem('customer_id'), data)
        .then((res) => {
          this.successPopupMessage('Project Created Successfully')
          const QueryParams = {
            template: false,
            livetask: false,
            project: true
          }
          this.$router.push({
            name: 'tasks-project',
            params: {payload:QueryParams}
          }).catch(() => {})
          this.clearProjectData()
        })
        .catch((e) => {
          this.projectData.liveTask = []
          this.projectData.attachLiveTask = []

          if (e.status === 422) {
            this.warningPopupMessage('Due Date is required')
          } else {
            this.warningPopupMessage('Something Went Wrong')
          }
        })
    },
    updateProject () {
      for (let index = 0; index < this.all_task_details.length; index++) {
        if (this.all_task_details[index].name !== '') {
          if (this.all_task_details[index].tId === null || this.all_task_details[index].tId === '' || this.all_task_details[index].id !== null || this.all_task_details[index].id !== '') {
            if (this.all_task_details[index].ResponsiblePersonData.length !== 0) {
              if (this.all_task_details[index].is_template === '1' || this.all_task_details[index].is_template === true) {
                this.all_task_details[index].is_template = true
              } else {
                this.all_task_details[index].is_template = false
              }

              if (this.all_task_details[index].ResponsiblePersonData.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].ResponsiblePersonData.length; i++) {
                  if ('user_type' in this.all_task_details[index].ResponsiblePersonData[i]) {
                    if (this.all_task_details[index].ResponsiblePersonData[i].user_type === 0) {
                      this.all_task_details[index].userResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].users_id) 
                    } else {
                      this.all_task_details[index].clientResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].users_id)
                    } 
                  } 
                  if ('pivot' in this.all_task_details[index].ResponsiblePersonData[i]) {
                    if (this.all_task_details[index].ResponsiblePersonData[i].pivot.responsible_persons_type === 0) {
                      this.all_task_details[index].userResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].pivot.responsible_persons_id) 
                    } else {
                      this.all_task_details[index].clientResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].pivot.responsible_persons_id)
                    }  
                  }
                }
              }

              if (this.all_task_details[index].ParticipantPersonData.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].ParticipantPersonData.length; i++) {
                  if ('user_type' in this.all_task_details[index].ParticipantPersonData[i]) {
                    if (this.all_task_details[index].ParticipantPersonData[i].user_type === 0) {
                      this.all_task_details[index].userParticipant.push(this.all_task_details[index].ParticipantPersonData[i].users_id) 
                    } else {
                      this.all_task_details[index].clientParticipant.push(this.all_task_details[index].ParticipantPersonData[i].users_id)
                    }  
                  } 
                  if ('pivot' in this.all_task_details[index].ParticipantPersonData[i]) {
                    if (this.all_task_details[index].ParticipantPersonData[i].pivot.participants_type === 0) {
                      this.all_task_details[index].userParticipant.push(this.all_task_details[index].ParticipantPersonData[i].pivot.participants_id) 
                    } else {
                      this.all_task_details[index].clientParticipant.push(this.all_task_details[index].ParticipantPersonData[i].pivot.participants_id)
                    }  
                  }
                }
              }

       
              if (this.all_task_details[index].observerPersonData.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].observerPersonData.length; i++) {
                  if ('user_type' in this.all_task_details[index].observerPersonData[i]) {
                    if (this.all_task_details[index].observerPersonData[i].user_type === 0) {
                      this.all_task_details[index].userObserver.push(this.all_task_details[index].observerPersonData[i].users_id) 
                    } else {
                      this.all_task_details[index].clientObserver.push(this.all_task_details[index].observerPersonData[i].users_id)
                    }  
                  } 
                  if ('pivot' in this.all_task_details[index].observerPersonData[i]) {
                    if (this.all_task_details[index].observerPersonData[i].pivot.observers_type === 0) {
                      this.all_task_details[index].userObserver.push(this.all_task_details[index].observerPersonData[i].pivot.observers_id) 
                    } else {
                      this.all_task_details[index].clientObserver.push(this.all_task_details[index].observerPersonData[i].pivot.observers_id)
                    }  
                  }
                }
              }
              if (this.all_task_details[index].selectedSubTaskData.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].selectedSubTaskData.length; i++) {
                  this.all_task_details[index].subtask.push(this.all_task_details[index].selectedSubTaskData[i].id) 
                }
              }
              if (this.all_task_details[index].selectedCRMData.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].selectedCRMData.length; i++) {
                  this.all_task_details[index].leads.push(this.all_task_details[index].selectedCRMData[i].leads_id) 
                }
              }
              if (this.all_task_details[index].reminderTime.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].reminderTime.length; i++) {
                  this.all_task_details[index].reminder.push({
                    reminder_type: 1,
                    reminder_time: this.all_task_details[index].reminderTime[i].reminder_time
                  }) 
                }
              }

              if (this.all_task_details[index].checklistRows.length !== 0 || this.all_task_details[index].checklist.length !== 0) {
                for (let index2 = 0; index2 < this.all_task_details[index].checklist.length; index2++) {
                  if ('todos' in this.all_task_details[index].checklist[index2]) {
                    for (let j = 0; j < this.all_task_details[index].checklist[index2].todos.length; j++) {
                      this.all_task_details[index].checklist[index2].todos[j].order_id = j + 1
                    }
                    if (this.all_task_details[index].checklist[index2].todos.length === 0) this.all_task_details[index].checklist.splice(index2, 1)
                  }
                }
                for (let i = 0; i < this.all_task_details[index].checklistRows.length; i++) {
                  if (this.all_task_details[index].checklistRows[i].items.length === 0) {
                    this.all_task_details[index].checklistRows.splice(index, 1)
                  } else {
                    const result = this.all_task_details[index].checklistRows[i].items.map(function (el) {
                      const o = Object.assign({}, el)
                      o.order_id = 0
                      return o
                    })
                    for (let j = 0; j < result.length; j++) {
                      this.all_task_details[index].checklistRows[i].items[j].order_id = j + 1
                    }
                    this.all_task_details[index].checklist.push({
                      name: `checklist${ i + 1}`,
                      todos: this.all_task_details[index].checklistRows[i].items
                    })
                  }
      
                }
              }
        
              this.projectData.liveTask.push(this.all_task_details[index]) 
            } else {
              this.warningPopupMessage('Responsible person is required')
              throw new Error('Stop script')
            }
          } else {
            this.projectData.attachLiveTask.push({
              id: this.all_task_details[index].tId,
              project_status_name: this.all_task_details[index].projectStatusTag
            })
          } 
        }
      }

      if (this.memberData.length !== 0) {
        for (let i = 0; i < this.memberData.length; i++) {
          if ('user_type' in this.memberData[i]) {
            if (this.memberData[i].user_type === 0) {
              this.projectData.userProjectMember.push(this.memberData[i].users_id) 
            } else {
              this.projectData.clientProjectMember.push(this.memberData[i].users_id)
            }
          } 
          if ('pivot' in this.memberData[i]) {
            if (this.memberData[i].pivot.members_type === 0) {
              this.projectData.userProjectMember.push(this.memberData[i].pivot.members_id) 
            } else {
              this.projectData.clientProjectMember.push(this.memberData[i].pivot.members_id)
            }  
          } 
        }
        this.projectData.userProjectMember = this.projectData.userProjectMember.filter((data, index) => {
          return this.projectData.userProjectMember.indexOf(data) === index
        })
        this.projectData.clientProjectMember = this.projectData.clientProjectMember.filter((data, index) => {
          return this.projectData.clientProjectMember.indexOf(data) === index
        })
      }
      for (let i = 0; i < this.allTaskStatus.length; i++) {
        this.projectData.projectStatusTag.push({
          name: this.allTaskStatus[i].name,
          weighted_order_id: i + 1
        }) 
      }
      this.projectData.liveTask.forEach(e => { delete e.ParticipantPersonData })
      this.projectData.liveTask.forEach(e => { delete e.ResponsiblePersonData })
      this.projectData.liveTask.forEach(e => { delete e.observerPersonData })
      this.projectData.liveTask.forEach(e => { delete e.checklistRows })
      
      const payload = {
        updateField: this.projectData  
      }
      this.updateProj(payload)
    },
    submitTaskFromProject (id, status) {
      this.projectUpdateId = id
      for (let index = 0; index < this.all_task_details.length; index++) {
        
        if (this.all_task_details[index].name !== '') {
          if (this.all_task_details[index].tId === null || this.all_task_details[index].tId === '' || this.all_task_details[index].id !== null || this.all_task_details[index].id !== '') {
            if (this.all_task_details[index].ResponsiblePersonData.length !== 0) {
              if (this.all_task_details[index].is_template === '1' || this.all_task_details[index].is_template === true) {
                this.all_task_details[index].is_template = true
              } else {
                this.all_task_details[index].is_template = false
              }

              if (this.all_task_details[index].ResponsiblePersonData.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].ResponsiblePersonData.length; i++) {
                  if ('user_type' in this.all_task_details[index].ResponsiblePersonData[i]) {
                    if (this.all_task_details[index].ResponsiblePersonData[i].user_type === 0) {
                      this.all_task_details[index].userResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].users_id) 
                    } else {
                      this.all_task_details[index].clientResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].users_id)
                    } 
                  } 
                  if ('pivot' in this.all_task_details[index].ResponsiblePersonData[i]) {
                    if (this.all_task_details[index].ResponsiblePersonData[i].pivot.responsible_persons_type === 0) {
                      this.all_task_details[index].userResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].pivot.responsible_persons_id) 
                    } else {
                      this.all_task_details[index].clientResponsiblePerson.push(this.all_task_details[index].ResponsiblePersonData[i].pivot.responsible_persons_id)
                    }  
                  }
                }
              }

              if (this.all_task_details[index].ParticipantPersonData.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].ParticipantPersonData.length; i++) {
                  if ('user_type' in this.all_task_details[index].ParticipantPersonData[i]) {
                    if (this.all_task_details[index].ParticipantPersonData[i].user_type === 0) {
                      this.all_task_details[index].userParticipant.push(this.all_task_details[index].ParticipantPersonData[i].users_id) 
                    } else {
                      this.all_task_details[index].clientParticipant.push(this.all_task_details[index].ParticipantPersonData[i].users_id)
                    }  
                  } 
                  if ('pivot' in this.all_task_details[index].ParticipantPersonData[i]) {
                    if (this.all_task_details[index].ParticipantPersonData[i].pivot.participants_type === 0) {
                      this.all_task_details[index].userParticipant.push(this.all_task_details[index].ParticipantPersonData[i].pivot.participants_id) 
                    } else {
                      this.all_task_details[index].clientParticipant.push(this.all_task_details[index].ParticipantPersonData[i].pivot.participants_id)
                    }  
                  }
                }
              }

       
              if (this.all_task_details[index].observerPersonData.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].observerPersonData.length; i++) {
                  if ('user_type' in this.all_task_details[index].observerPersonData[i]) {
                    if (this.all_task_details[index].observerPersonData[i].user_type === 0) {
                      this.all_task_details[index].userObserver.push(this.all_task_details[index].observerPersonData[i].users_id) 
                    } else {
                      this.all_task_details[index].clientObserver.push(this.all_task_details[index].observerPersonData[i].users_id)
                    }  
                  } 
                  if ('pivot' in this.all_task_details[index].observerPersonData[i]) {
                    if (this.all_task_details[index].observerPersonData[i].pivot.observers_type === 0) {
                      this.all_task_details[index].userObserver.push(this.all_task_details[index].observerPersonData[i].pivot.observers_id) 
                    } else {
                      this.all_task_details[index].clientObserver.push(this.all_task_details[index].observerPersonData[i].pivot.observers_id)
                    }  
                  }
                }
              }
              if (this.all_task_details[index].selectedSubTaskData.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].selectedSubTaskData.length; i++) {
                  this.all_task_details[index].subtask.push(this.all_task_details[index].selectedSubTaskData[i].id) 
                }
              }
              if (this.all_task_details[index].selectedCRMData.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].selectedCRMData.length; i++) {
                  this.all_task_details[index].leads.push(this.all_task_details[index].selectedCRMData[i].leads_id) 
                }
              }
              if (this.all_task_details[index].reminderTime.length !== 0) {
                for (let i = 0; i < this.all_task_details[index].reminderTime.length; i++) {
                  this.all_task_details[index].reminder.push({
                    reminder_type: 1,
                    reminder_time: this.all_task_details[index].reminderTime[i].reminder_time
                  }) 
                }
              }

              if (this.all_task_details[index].checklistRows.length !== 0 || this.all_task_details[index].checklist.length !== 0) {
                for (let index2 = 0; index2 < this.all_task_details[index].checklist.length; index2++) {
                  if ('todos' in this.all_task_details[index].checklist[index2]) {
                    for (let j = 0; j < this.all_task_details[index].checklist[index2].todos.length; j++) {
                      this.all_task_details[index].checklist[index2].todos[j].order_id = j + 1
                    }
                    if (this.all_task_details[index].checklist[index2].todos.length === 0) this.all_task_details[index].checklist.splice(index2, 1)
                  }
                }
                for (let i = 0; i < this.all_task_details[index].checklistRows.length; i++) {
                  if (this.all_task_details[index].checklistRows[i].items.length === 0) {
                    this.all_task_details[index].checklistRows.splice(index, 1)
                  } else {
                    const result = this.all_task_details[index].checklistRows[i].items.map(function (el) {
                      const o = Object.assign({}, el)
                      o.order_id = 0
                      return o
                    })
                    for (let j = 0; j < result.length; j++) {
                      this.all_task_details[index].checklistRows[i].items[j].order_id = j + 1
                    }
                    this.all_task_details[index].checklist.push({
                      name: `checklist${ i + 1}`,
                      todos: this.all_task_details[index].checklistRows[i].items
                    })
                  }
      
                }
              }
              this.all_task_details[index].projectStatusTag = status
              this.projectData.liveTask.push(this.all_task_details[index]) 
            } else {
              this.warningPopupMessage('Responsible person is required')
              throw new Error('Stop script')
            }
          } else {
            this.projectData.attachLiveTask.push({
              id: this.all_task_details[index].tId,
              project_status_name: this.all_task_details[index].projectStatusTag
            })
          } 
        }
      }
      this.projectData.liveTask.forEach(e => { delete e.ParticipantPersonData })
      this.projectData.liveTask.forEach(e => { delete e.ResponsiblePersonData })
      this.projectData.liveTask.forEach(e => { delete e.observerPersonData })
      this.projectData.liveTask.forEach(e => { delete e.checklistRows })
      this.submitTaskFromProjectDetails = true

      const liveTaskData = {
        liveTask: this.projectData.liveTask,
        addTaskFromKanban: true //as per nilesh requirement
      }
      const payload = {
        updateField: liveTaskData
      }
      this.updateProj(payload)
    },
    ...mapActions(['SET_UPDATE_DATA']),
    updateProj (data) {       
      projectUpdate(localStorage.getItem('customer_id'), this.projectUpdateId, data)
        .then((res) => {
          this.successPopupMessage('Project Updated Successfully')
          console.log(this.submitTaskFromProjectDetails)
          if (this.submitTaskFromProjectDetails === true) {
            this.SET_UPDATE_DATA(this.submitTaskFromProjectDetails)
            this.submitTaskFromProjectDetails = false
          } else {
            const QueryParams = {
              template: false,
              livetask: false,
              project: true
            }
            this.$router.push({
              name: 'tasks-project',
              params: {payload:QueryParams}
            }).catch(() => {})
          }
          this.clearProjectData()
        })
        .catch((e) => {
          
          this.projectData.liveTask = []
          this.projectData.attachLiveTask = []
          this.warningPopupMessage('Something Went Wrong')
        })
    },
    exportToProject () {
      for (let index = 0; index < this.selected.length; index++) {
        if (index !== 0) { // for SBR-968
          this.addNewTask()
        }
        if (this.selected[index].reference_id === null || this.selected[index].reference_id === '') {
          this.all_task_details[this.all_task_details.length - 1].name = this.selected[index].name
          this.all_task_details[this.all_task_details.length - 1].task_priority_id = this.selected[index].task_priority.id
          this.all_task_details[this.all_task_details.length - 1].details = this.selected[index].details
          this.all_task_details[this.all_task_details.length - 1].comments = this.selected[index].comments
          this.all_task_details[this.all_task_details.length - 1].due_date = this.selected[index].due_date
          this.all_task_details[this.all_task_details.length - 1].is_template = 2
          this.all_task_details[this.all_task_details.length - 1].ResponsiblePersonData = this.selected[index].userResponsiblePerson.concat(this.selected[index].clientResponsiblePerson)
        } else {
          this.all_task_details[this.all_task_details.length - 1].name = this.selected[index].name
          this.all_task_details[this.all_task_details.length - 1].tId = this.selected[index].id
          this.all_task_details[this.all_task_details.length - 1].task_priority_id = this.selected[index].task_priority.id
          this.all_task_details[this.all_task_details.length - 1].is_template = 2
          this.all_task_details[this.all_task_details.length - 1].details = this.selected[index].details
          this.all_task_details[this.all_task_details.length - 1].comments = this.selected[index].comments
          this.all_task_details[this.all_task_details.length - 1].due_date = this.selected[index].due_date
          this.all_task_details[this.all_task_details.length - 1].from_time = this.selected[index].from_time
          this.all_task_details[this.all_task_details.length - 1].to_time = this.selected[index].to_time
          this.all_task_details[this.all_task_details.length - 1].is_tracking_active = this.selected[index].is_tracking_active
          this.all_task_details[this.all_task_details.length - 1].ResponsiblePersonData = this.selected[index].userResponsiblePerson.concat(this.selected[index].clientResponsiblePerson)
          this.all_task_details[this.all_task_details.length - 1].ParticipantPersonData = this.selected[index].userParticipant.concat(this.selected[index].clientParticipant)
          this.all_task_details[this.all_task_details.length - 1].observerPersonData = this.selected[index].userObserver.concat(this.selected[index].clientObserver)
          this.all_task_details[this.all_task_details.length - 1].selectedSubTaskData = this.selected[index].subtask
          
          for (let i = 0; i < this.selected[index].tags.length; i++) {
            this.all_task_details[this.all_task_details.length - 1].tags.push(this.selected[index].tags[i].id)
          }
          this.all_task_details[this.all_task_details.length - 1].selectedCRMData = this.selected[index].leads
          if (this.selected[index].taskReminder.length !== 0) {
            for (let i = 0; i < this.selected[index].taskReminder.length; i++) {
              this.addReminderProj(this.all_task_details.length - 1)
            }
            for (let i = 0; i < this.selected[index].taskReminder.length; i++) {
              this.all_task_details[this.all_task_details.length - 1].reminderTime[i].reminder_time = this.selected[index].taskReminder[i].reminder_time
            }
          }
          this.all_task_details[this.all_task_details.length - 1].checklist = this.selected[index].checklist.sort((a, b) => parseFloat(a.order_id) - parseFloat(b.order_id))
          this.all_task_details[this.all_task_details.length - 1].checklist.map((row, index5) => {
            const itemStatusCal = this.all_task_details[this.all_task_details.length - 1].checklist[index5].todos.filter(ele => {
              return ele.is_completed === true
            })
            Object.assign(row, { itemStatusCal })
          })
          this.all_task_details[this.all_task_details.length - 1].checklist.map((row, index) => {
            const showTextBox = []
            Object.assign(row, { showTextBox })
          })
        } 
      }
      this.selected = []
      this.importActive = false
    },
    clearProjectData () {
      this.projectData.name = ''
      this.projectData.details = ''
      this.projectData.due_date = ''
      this.projectData.projectStatusTag = []
      this.projectData.liveTask = []
      this.projectData.attachLiveTask = []
      this.projectData.clientProjectMember = []
      this.projectData.userProjectMember = []
      this.memberData = []
      this.allTaskStatus = []
      this.all_task_details = [
        {
          id: '',
          tId: '',
          name : '',
          due_date: '',
          task_priority_id : '',
          comments: '',
          details: '',
          is_tracking_active: false,
          clientObserver:[],
          clientParticipant:[],
          clientResponsiblePerson:[],
          userObserver:[],
          userParticipant:[],
          userResponsiblePerson:[],
          timeSchedules:[],
          projectStatusTag: '',
          checklist:[],
          is_template: false,
          ResponsiblePersonData: [],
          ParticipantPersonData: [],
          observerPersonData: [],
          selectedSubTaskData: [],
          selectedCRMData: [],
          reminderTime: [],
          from_time: '',
          to_time: '',
          checklistRows: [],
          tags: [],
          subtask: [],
          leads: [],
          reminder: [],
          configdateTimePicker: {
            enableTime: true,
            enableSeconds: true,
            noCalendar: false,
            maxDate: '',
            maxTime: '',
            altInput: true,
            altFormat: 'j F, Y G:i K',
            dateFormat: 'Y-m-d H:i:S'
          },
          configdateTimePicker2: {
            enableTime: true,
            //enableSeconds: true,
            noCalendar: false,
            maxDate: '',
            minDate: new Date(),
            maxTime: '',
            altInput: true,
            altFormat: 'j F, Y G:i K',
            dateFormat: 'Y-m-d H:i:S'
          }
        }
      ]
        
    },
    showProject (id) {
      this.projectUpdateId = id
      projectShow(localStorage.getItem('customer_id'), id)
        .then((res) => {
          const fetchedProject = res.data.data.project
          this.projectData.name = fetchedProject.name
          this.projectData.due_date = fetchedProject.due_date
          this.projectData.details = fetchedProject.details
          this.memberData = fetchedProject.userProjectMember.concat(fetchedProject.clientProjectMember)
          this.allTaskStatus = fetchedProject.projectStatusTag.sort((a, b) => parseFloat(a.weighted_order_id) - parseFloat(b.weighted_order_id))
          for (let index = 0; index < fetchedProject.task.length - 1; index++) {
            this.addNewTask()
          }
          for (let index = 0; index < fetchedProject.task.length; index++) {
            this.all_task_details[index].name = fetchedProject.task[index].name
            this.all_task_details[index].id = fetchedProject.task[index].id
            if (fetchedProject.task[index].projectStatusTag !== null) {
              this.all_task_details[index].projectStatusTag = fetchedProject.task[index].projectStatusTag.name // dependancy on nilesh
            }
            if (fetchedProject.task[index].task_priority !== null) {
              this.all_task_details[index].task_priority_id = fetchedProject.task[index].task_priority.id
            }
            this.all_task_details[index].details = fetchedProject.task[index].details
            this.all_task_details[index].comments = fetchedProject.task[index].comments
            this.all_task_details[index].due_date = fetchedProject.task[index].due_date
            this.all_task_details[index].from_time = fetchedProject.task[index].from_time
            this.all_task_details[index].to_time = fetchedProject.task[index].to_time
            this.all_task_details[index].is_tracking_active = fetchedProject.task[index].is_tracking_active
            this.all_task_details[index].checklist = fetchedProject.task[index].checklist.sort((a, b) => parseFloat(a.order_id) - parseFloat(b.order_id))
            this.all_task_details[index].checklist.map((row, index5) => {
              const itemStatusCal = this.all_task_details[index].checklist[index5].todos.filter(ele => {
                return ele.is_completed === true
              })
              Object.assign(row, { itemStatusCal })
            })
            this.all_task_details[index].checklist.map((row, index) => {
              const showTextBox = []
              Object.assign(row, { showTextBox })
            })
            this.all_task_details[index].observerPersonData = fetchedProject.task[index].userObserver.concat(fetchedProject.task[index].clientObserver)
            this.all_task_details[index].ParticipantPersonData = fetchedProject.task[index].userParticipant.concat(fetchedProject.task[index].clientParticipant)
            this.all_task_details[index].ResponsiblePersonData = fetchedProject.task[index].userResponsiblePerson.concat(fetchedProject.task[index].clientResponsiblePerson)
            this.all_task_details[index].selectedSubTaskData = fetchedProject.task[index].subtask
            //this.all_task_details[index].tags = fetchedProject.task[index].tags
            for (let i = 0; i < fetchedProject.task[index].tags.length; i++) {
              this.all_task_details[index].tags.push(fetchedProject.task[index].tags[i].id)
            }
            this.all_task_details[index].selectedCRMData = fetchedProject.task[index].leads
            if (fetchedProject.task[index].taskReminder.length !== 0) {
              for (let i = 0; i < fetchedProject.task[index].taskReminder.length; i++) {
                this.addReminderProj(index)
              }
              
              for (let i = 0; i < fetchedProject.task[index].taskReminder.length; i++) {
                this.all_task_details[index].reminderTime[i].reminder_time = fetchedProject.task[index].taskReminder[i].reminder_time
              }
            }   
          }
        })
        .catch((e) => {
          
        })
    },
    statusLogProject (event) {
      console.log(event)
    },
    addProjModal (data, index) {
      this.taskRow = index
      if (data === 'subTask') {
        this.popupActiveSubTask = true
      } else {
        this.popupActiveCRM = true
      }
    },
    addProjMicData (data) {
      if (data === 'subTask') {
        const arr = []
        for (let i = 0; i < this.selectedSubTask.length; i++) {
          arr.push({
            name: this.selectedSubTask[i].name,
            id: this.selectedSubTask[i].id
          })
        }
        const res2 = this.all_task_details[this.taskRow].selectedSubTaskData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.id === o2.id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].id
            this.all_task_details[this.taskRow].selectedSubTaskData = this.all_task_details[this.taskRow].selectedSubTaskData.filter(
              (item) => item.id !== idToRemove
            )
          }
        }
        this.all_task_details[this.taskRow].selectedSubTaskData = arr.concat(this.all_task_details[this.taskRow].selectedSubTaskData)
        this.popupActiveSubTask = false
        this.selectedSubTask = []
      } else {
        const arr = []
        for (let i = 0; i < this.selectedCRM.length; i++) {
          arr.push({
            lead_first_name: this.selectedCRM[i].lead_first_name,
            leads_id: this.selectedCRM[i].leads_id
          })
        }
        const res2 = this.all_task_details[this.taskRow].selectedCRMData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.leads_id === o2.leads_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].leads_id
            this.all_task_details[this.taskRow].selectedCRMData = this.all_task_details[this.taskRow].selectedCRMData.filter(
              (item) => item.leads_id !== idToRemove
            )
          }
        }
        this.all_task_details[this.taskRow].selectedCRMData = arr.concat(this.all_task_details[this.taskRow].selectedCRMData)
        this.popupActiveCRM = false
        this.selectedCRM = []
      }
      
    },
    addReminderProj (index) {
      this.all_task_details[index].reminderTime.push({reminder_time: ''})
    },
    removeReminderProj (index, index2) {
      this.all_task_details[index].reminderTime.splice(index2, 1)
    },
    ProjectUpdateCalendar (index) {
      this.all_task_details[index].configdateTimePicker.maxDate = this.all_task_details[index].due_date.split(' ')[0]
      this.all_task_details[index].configdateTimePicker.maxTime = this.all_task_details[index].due_date.split(' ')[1]
    },
    ProjectDueDate () {
      for (let index = 0; index < this.all_task_details.length; index++) {
        this.all_task_details[index].configdateTimePicker2.maxDate = this.projectData.due_date.split(' ')[0]
        this.all_task_details[index].configdateTimePicker2.maxTime = this.projectData.due_date.split(' ')[1]  
      }
    },
    successPopupMessage (msg) {
      this.$vs.notify({
        title: 'Success',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    warningPopupMessage (msg) {
      this.$vs.notify({
        title: 'Warning',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
    }
  }
}
